import React from 'react';
import IconLink from './IconLink';
import { Box, Accordion, AccordionSummary, AccordionDetails, Typography, Chip } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

class PortfolioBlock extends React.Component {
    state = { expanded: false }

    handleAccordionChange = (panel) => (event, isExpanded) => {
        this.setState({ expanded: isExpanded ? panel : false });
    };

    render() {
        const { image, live, source, title, description, timerange, techstack, darkMode } = this.props;
        const { expanded } = this.state;

        const titleColor = darkMode ? '#fff' : '#111';
        const textColor = darkMode ? 'rgba(255,255,255,0.8)' : 'rgba(0,0,0,0.75)';
        const subtleColor = darkMode ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.4)';
        const cardBg = darkMode
            ? 'rgba(255,255,255,0.07)'
            : 'rgba(255,255,255,0.75)';
        const cardBorder = darkMode
            ? '1px solid rgba(255,255,255,0.12)'
            : '1px solid rgba(0,0,0,0.08)';

        return (
            <Box
                sx={{
                    borderRadius: '16px',
                    background: cardBg,
                    backdropFilter: 'blur(12px)',
                    border: cardBorder,
                    borderTop: '3px solid rgb(0,255,164)',
                    padding: '20px',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                    '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: darkMode
                            ? '0 8px 32px rgba(0,255,164,0.15)'
                            : '0 8px 32px rgba(0,0,0,0.12)',
                    },
                }}
            >
                <Typography
                    variant="h6"
                    sx={{ fontWeight: 700, color: titleColor, textAlign: 'center', lineHeight: 1.3 }}
                >
                    {title}
                </Typography>

                {image && (
                    <Box
                        component="img"
                        src={image}
                        alt="mockup"
                        sx={{ width: '100%', borderRadius: 2 }}
                    />
                )}

                <Box display="flex" gap="10px" justifyContent="center">
                    {live && <IconLink link={live} title="Live Demo" icon="fa fa-safari" />}
                    {source && <IconLink link={source} title="Source Code" icon="fa fa-code" />}
                </Box>

                <Accordion
                    expanded={expanded === 'panel1'}
                    onChange={this.handleAccordionChange('panel1')}
                    sx={{
                        background: 'transparent',
                        boxShadow: 'none',
                        '&:before': { display: 'none' },
                    }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: 'rgb(0,255,164)' }} />}
                        sx={{
                            padding: 0,
                            minHeight: 'unset',
                            '& .MuiAccordionSummary-content': { margin: 0 },
                        }}
                    >
                        <Typography sx={{ color: 'rgb(0,255,164)', fontWeight: 600, fontSize: '0.9rem' }}>
                            Details
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ padding: '8px 0 0 0' }}>
                        <Typography sx={{ fontSize: '0.85rem', color: textColor, lineHeight: 1.6 }}>
                            {description}
                        </Typography>
                        {timerange && (
                            <Typography variant="body2" sx={{ color: subtleColor, marginTop: '8px' }}>
                                Time: {timerange}
                            </Typography>
                        )}
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, marginTop: '10px' }}>
                            {techstack.map((tech, index) => (
                                <Chip
                                    key={index}
                                    label={tech}
                                    size="small"
                                    sx={{
                                        background: 'rgba(0,255,164,0.12)',
                                        color: darkMode ? 'rgb(0,255,164)' : 'rgb(0,180,120)',
                                        border: '1px solid rgba(0,255,164,0.3)',
                                        fontSize: '0.75rem',
                                    }}
                                />
                            ))}
                        </Box>
                    </AccordionDetails>
                </Accordion>
            </Box>
        );
    }
}

export default PortfolioBlock;
